import { memo } from 'react'

import { useSelector } from 'react-redux'

import { DrawerContent, DrawerOverlay } from '@chakra-ui/react'

import { Drawer } from '@/components/overlays'
import { DrawerScrollContainer } from '@/components/ui'
import { useGuardTourQuery } from '@/graphql/generated/hooks'
import { selectGuardTour } from '@/redux/ui/uiSlice'

import { formatData } from '../utils/format'
import { GuardTourDrawerTourContent } from './GuardTourDrawerTourContent'
import { GuardTourHeader } from './GuardTourHeader'

export interface GuardTourDrawerIProps {
  isOpen: boolean
  onClose: () => void
}

export const GuardTourDrawer = memo(
  ({ isOpen, onClose }: GuardTourDrawerIProps) => {
    const { id } = useSelector(selectGuardTour)
    const { data, loading: isLoading } = useGuardTourQuery({
      fetchPolicy: 'network-only',
      variables: {
        id,
      },
    })
    const drawerData = formatData(data?.guardTour)

    return (
      <Drawer isOpen={isOpen} onClose={onClose} placement='right' size='md'>
        <DrawerOverlay />
        <DrawerContent>
          <GuardTourHeader
            isLoading={isLoading}
            onClose={onClose}
            tourPlan={drawerData}
          />
          <DrawerScrollContainer px='30px' py='30px'>
            <GuardTourDrawerTourContent
              drawerData={drawerData}
              isLoading={isLoading}
            />
          </DrawerScrollContainer>
        </DrawerContent>
      </Drawer>
    )
  }
)
